import { render, staticRenderFns } from "./StuTrainAudit.vue?vue&type=template&id=37913b7e"
import script from "./StuTrainAudit.vue?vue&type=script&lang=js"
export * from "./StuTrainAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports